<template>
  <v-col :cols="12" style="margin-top: -50px;" :class="{'px-0': true}">


    <material-card color="green">
      <template v-slot:header>
        <div class="px-3">
          <h4 class="title font-weight-light mb-0">Finance</h4>
        </div>
        <v-spacer />

      </template>
      <v-simple-table class="account-info-finance">
        <template v-slot:default>
          <tbody>
            <tr v-if="activeAccount.account.data.promocode">
              <td><b>Promocode</b></td>
              <td align="right">{{ activeAccount.account.data.promocode }}</td>
            </tr>
            <tr>
              <td><b>Currency</b></td>
              <td align="right">{{ activeAccount.account.currency }}</td>
            </tr>
            <tr>
              <td><b>Balance</b></td>
              <td align="right">{{ activeAccount.account.balance }}</td>
            </tr>
            <tr :class="{ 'highlighted-row': activeAccount.account.safebox_balance > 0 }">
              <td>
                <v-icon
                  v-if="activeAccount.account.safebox_balance > 0"
                  class="mr-1"
                  color="error"
                  small
                >
                  mdi-lock
                </v-icon>
                <b>Saved in Safebox</b>
              </td>
              <td align="right">
                <v-btn
                  v-if="$store.state.auth.checkAccess({key: 'safebox_management', value: true})"
                  color="primary"
                  icon
                  @click="safebox.dialog = true, safebox.mode = 'withdraw'"
                >
                  <v-icon>
                    mdi-minus
                  </v-icon>
                </v-btn>
                {{ activeAccount.account.safebox_balance }}
                <v-btn
                  v-if="$store.state.auth.checkAccess({key: 'safebox_management', value: true})"
                  color="primary"
                  icon
                  @click="safebox.dialog = true, safebox.mode = 'deposit'"
                >
                  <v-icon>
                    mdi-plus
                  </v-icon>
                </v-btn>
              </td>
            </tr>
            <tr v-if="trueplayFormatted">
              <td><b>Trueplay Balance</b></td>
              <td
                v-text="trueplayFormatted"
                align="right"
              />
            </tr>
            <tr>
              <td><b>Withdraw Allowed</b></td>
              <!--            <td align="right">{{ activeAccount.account.withdraw_allowed || 0 }}</td>-->

              <td align="right">
                <v-text-field
                  v-model="activeAccount.account.withdraw_allowed"
                  small
                  hide-details
                  type="number"
                  :readonly="!$store.state.auth.checkAccess({key: 'withdraw_pending_limit', value: true})"
                  :append-icon="$store.state.auth.checkAccess({key: 'withdraw_pending_limit', value: true}) ? 'mdi-content-save' : ''"
                  @click:append="toUpdate($event, 'withdraw_allowed', 'Change withdraw limit?')"
                  class="withdraw-limit-tf"
                  :style="{width: withdrawAllowedLength + 'px'}"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>
                <b>Withdraw limits</b>
                <v-btn
                  icon
                  class="ml-2"
                  @click="openWithdrawLimitForm(activeAccount.account.withdraw_limits)"
                >
                  <v-icon small>mdi-pencil</v-icon>
                </v-btn>
                <default-history
                  width="550"
                  style="display: inline-block"
                  type="withdraw_limits"
                  handler="default"
                  icon="history"
                  title="Withdraw Limits Change History"
                >
                  <template v-slot:from="{ item }">
                    <template v-for="v in `${item}`.split(',')">
                      <div style="white-space: nowrap">{{ v }}</div>
                    </template>
                  </template>

                  <template v-slot:to="{ item }">
                    <template v-for="v in `${item}`.split(',')">
                      <div style="white-space: nowrap">{{ v }}</div>
                    </template>
                  </template>
                </default-history>
                <br />
                Source: {{ activeAccount.account.withdraw_limits.level || '-' }}

                <withdraw-limit-update
                  v-model="limit.dialog"
                  :limit="limit.item"
                  :readonly="!canAdjustWithdrawalLimits"
                >
                  <template v-slot:action="{ item }">

                    <v-row class="mt-5 mx-0 px-0">
                      <v-btn
                        small
                        color="info lighten-2"
                        :loading="limit.loading"
                        :disabled="limit.loading"
                        @click="limit.dialog = false"
                      >
                        Close
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="item.level == 'personal'"
                        small
                        color="warning"
                        :loading="limit.loading"
                        :disabled="limit.loading"
                        @click="saveWithdrawLimit(item, true)"
                      >
                        Remove
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="canAdjustWithdrawalLimits"
                        small
                        color="primary"
                        :loading="limit.loading"
                        :disabled="limit.loading"
                        @click="saveWithdrawLimit(item)"
                      >
                        Save
                      </v-btn>
                    </v-row>
                  </template>


                </withdraw-limit-update>
              </td>
              <td align="right">
                <v-progress-linear
                  :value="dailyLimitPercent"
                  color="green lighten-2"
                  rounded
                  height="17"
                  class="mb-1 mt-1"
                >
                  <template v-slot:default="{ value }">
                    Daily: {{ activeAccount.account.withdraw_limits_stats.day || 0 }}/{{ activeAccount.account.withdraw_limits.max_per_day || 0 }}
                  </template>
                </v-progress-linear>

                <v-progress-linear
                  :value="weeklyLimitPercent"
                  color="green lighten-2"
                  rounded
                  height="17"
                  class="mb-1"
                >
                  <template v-slot:default="{ value }">
                    Week: {{ activeAccount.account.withdraw_limits_stats.week || 0 }}/{{ activeAccount.account.withdraw_limits.max_per_week || 0 }}
                  </template>
                </v-progress-linear>

                <v-progress-linear
                  :value="monthlyLimitPercent"
                  color="green lighten-2"
                  rounded
                  height="17"
                  class="mb-1"
                >
                  <template v-slot:default="{ value }">
                    Month: {{ activeAccount.account.withdraw_limits_stats.month || 0 }}/{{ activeAccount.account.withdraw_limits.max_per_month || 0 }}
                  </template>
                </v-progress-linear>

                <div class="text-center">
                  <b>Max:</b> {{ activeAccount.account.withdraw_limits.max }} | <b>Min:</b> {{ activeAccount.account.withdraw_limits.min }}
                </div>
              </td>
            </tr>
            <tr v-if="activeAccount.account.data.zimpler_user_id">
              <td><b>Zimpler Day Limit</b></td>
              <td align="right">
                <v-text-field
                  v-model="activeAccount.account.data.zimpler_withdraw_limits.day"
                  small
                  hide-details
                  type="number"
                  :readonly="!$store.state.auth.checkAccess({key: 'withdraw_pending_limit', value: true})"
                  :append-icon="$store.state.auth.checkAccess({key: 'withdraw_pending_limit', value: true}) ? 'mdi-content-save' : ''"
                  @click:append="toUpdate($event, 'data.zimpler_withdraw_limits.day', 'Change withdraw limit?')"
                  class="withdraw-limit-tf"
                  :style="{width: withdrawAllowedLength + 'px'}"
                ></v-text-field>
              </td>
            </tr>
            <tr v-if="activeAccount.account.data.zimpler_user_id">
              <td><b>Zimpler Week limit</b></td>
              <td align="right">
                <v-text-field
                  v-model="activeAccount.account.data.zimpler_withdraw_limits.week"
                  small
                  hide-details
                  type="number"
                  :readonly="!$store.state.auth.checkAccess({key: 'withdraw_pending_limit', value: true})"
                  :append-icon="$store.state.auth.checkAccess({key: 'withdraw_pending_limit', value: true}) ? 'mdi-content-save' : ''"
                  @click:append="toUpdate($event, 'data.zimpler_withdraw_limits.week', 'Change withdraw limit?')"
                  class="withdraw-limit-tf"
                  :style="{width: withdrawAllowedLength + 'px'}"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td colspan="2">
                <v-combobox
                  :append-icon="$store.state.auth.checkAccess({key: 'trusted_accounts', value: true}) ? 'mdi-content-save' : ''"
                  @click:append="toUpdate($event,'data.whitelisted', 'Do you want to change whitelist?')"
                  v-model="activeAccount.account.data.whitelisted"
                  :items="activeAccount.paymethods.items"
                  item-text="name"
                  item-value="name"
                  multiple
                  hide-details
                  :return-object="false"
                  label="Whitelisted paymethods"
                >
                  <!--<template v-slot:item="{ item, index }">-->
                  <!--  <v-list-item class="select-item-border">-->
                  <!--      <v-icon class="mr-2" color="primary">check_box</v-icon>-->
                  <!--      {{ item }}-->
                  <!--  </v-list-item>-->
                  <!--</template>-->
                  <template v-slot:selection="{ item: chipItem, index }">
                    <span v-if="index < 4">{{ index != 0 ? ', ' : '' }}{{ chipItem.text || chipItem }}</span>
                    <span
                      class="caption ml-3"
                      v-if="index === 4 && (activeAccount.account.data.whitelisted || []).length > 4"
                    >(+{{ (activeAccount.account.data.whitelisted || []).length - 4 }} others)</span>
                  </template>
                  <template #append-outer>
                    <v-btn
                      text
                      color="primary"
                      :disabled="!canSelectAllPaymethods"
                      @click="onSelectAllPaymethods"
                    >
                      Add All
                    </v-btn>
                  </template>
                </v-combobox>
              </td>
            </tr>
            <tr>
              <td><b>Bonus</b></td>
              <td align="right">{{ activeAccount.account.bonus.amount || 0 }} {{ activeAccount.account.currency }} ({{ (activeAccount.account.bonus.rollover_init - activeAccount.account.bonus.rollover).toFixed(2) }}/{{ activeAccount.account.bonus.rollover_init }})</td>
            </tr>
            <tr>
              <td><b>Freespins</b></td>
              <td align="right">{{ activeAccount.account.freespins }}</td>
            </tr>
            <tr :class="{ 'highlighted-row': (activeAccount.totalOpenBets.amount || 0) > 0 }">
              <td>
                <v-icon
                  v-if="activeAccount.totalOpenBets.amount"
                  class="mr-1"
                  color="error"
                  small
                >
                  mdi-dice-5
                </v-icon>
                <b>Open Bets</b></td>
              <td align="right">{{ activeAccount.totalOpenBets.amount || 0 }} {{ activeAccount.account.currency }}</td>
            </tr>
            <tr>
              <td><b>Total Deposit</b></td>
              <td align="right">{{ activeAccount.account.total.deposit }}</td>
            </tr>
            <tr>
              <td><b>Average Deposit</b></td>
              <td align="right">{{ activeAccount.account.total.deposit_average }}</td>
            </tr>
            <tr>
              <td><b>Last Deposit</b></td>
              <td align="right">{{ activeAccount.account.total.deposit_last }}</td>
            </tr>
            <tr>
              <td><b>Left to wager</b></td>
              <td align="right">{{ activeAccount.account.rollover_left || 0 }}</td>
            </tr>
            <tr v-if="activeAccount.account.total.chargeback > 0">
              <td><b>Total Chargeback</b></td>
              <td align="right">{{ activeAccount.account.total.chargeback }}</td>
            </tr>
            <tr v-if="activeAccount.account.total.refund > 0">
              <td><b>Total Refund</b></td>
              <td align="right">{{ activeAccount.account.total.refund }}</td>
            </tr>
            <tr>
              <td><b>Total Withdrawals</b></td>
              <td align="right">{{ activeAccount.account.total.withdraw }}</td>
            </tr>
            <tr>
              <td><b>Net Deposit</b></td>
              <td align="right">{{ (activeAccount.account.total.deposit - activeAccount.account.total.withdraw).toFixed(2) }}</td>
            </tr>
            <tr :class="{ 'highlighted-row': activeAccount.account.total.withdraw_pending > 0 }">
              <td>
                <v-icon
                  v-if="activeAccount.account.total.withdraw_pending"
                  class="mr-1"
                  color="error"
                  small
                >
                  mdi-lock
                </v-icon>
                <b>Locked For Withdrawals</b>
              </td>
              <td align="right">{{ activeAccount.account.total.withdraw_pending }}</td>
            </tr>
            <tr>
              <td><b>Manual Deposit</b></td>
              <td align="right">{{ activeAccount.account.total.manual_deposit }}</td>
            </tr>
            <tr>
              <td><b>Manual Withdrawals</b></td>
              <td align="right">{{ activeAccount.account.total.manual_withdraw }}</td>
            </tr>
            <tr>
              <td><b>Withdraw Request Limit</b></td>
              <td align="right">
                <v-text-field
                  v-model="activeAccount.account.data.withdraw_pending_limit"
                  small
                  hide-details
                  type="number"
                  min="0"
                  :readonly="!$store.state.auth.checkAccess({key: 'withdraw_pending_limit', value: true})"
                  :append-icon="$store.state.auth.checkAccess({key: 'withdraw_pending_limit', value: true}) ? 'mdi-content-save' : ''"
                  @click:append="toUpdate($event, 'data.withdraw_pending_limit', 'Change maximal withdraw requests?')"
                  class="withdraw-request-limit-tf"
                ></v-text-field>
              </td>
            </tr>
            <tr>
              <td>
                <b>Total Bonuses</b>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="blue darken-4" class="ml-2" style="cursor: pointer;" v-on="on">info</v-icon>
                  </template>
                  <span>
                  Bonus Deposit: {{ activeAccount.account.total.bonus }}<br />
                  Bonus Withdraw: {{ activeAccount.account.total.bonus_withdraw }}<br />
                   <span v-for="(info, type) in activeAccount.account.total.bonus_info" :key="type">
                    {{ capitalize(type) }}: count: {{ info.count }}, amount: {{ info.amount }}<br />
                   </span>
                </span>
                </v-tooltip>
              </td>
              <td align="right">{{ (activeAccount.account.total.bonus - activeAccount.account.total.bonus_withdraw).toFixed(2) }} ({{ (((activeAccount.account.total.bonus - activeAccount.account.total.bonus_withdraw) / (activeAccount.account.total.deposit > 0 ? activeAccount.account.total.deposit : 0.001)) * 100).toFixed(2) }}%)</td>
            </tr>
            <tr>
              <td>
                <b>Bonus Generosity</b>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="blue darken-4" class="ml-2" style="cursor: pointer;" v-on="on">info</v-icon>
                  </template>
                  <span>
                    Total Bonuses - (Total deposits - Total withdrawals)
                  </span>
                </v-tooltip>
              </td>
              <td align="right">{{ activeAccount.account.total.bonus_generosity }}</td>
            </tr>
            <tr>
              <td><b>Total Cash Bonuses</b></td>
              <td align="right">{{ (activeAccount.account.total.cash_bonus).toFixed(2) }}</td>
            </tr>
            <tr>
              <td>
                <b>Total Bets</b>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="blue darken-4" class="ml-2" style="cursor: pointer;" v-on="on">info</v-icon>
                  </template>
                  <span>
                  Balance: {{ activeAccount.account.total.bet_balance }}<br />
                  Bonus: {{ activeAccount.account.total.bet_bonus }}
                </span>
                </v-tooltip>
              </td>
              <td align="right">{{ activeAccount.account.total.bet }}</td>
            </tr>
            <tr>
              <td>
                <b>Total Wins</b>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="blue darken-4" class="ml-2" style="cursor: pointer;" v-on="on">info</v-icon>
                  </template>
                  <span>
                  Balance: {{ activeAccount.account.total.win_balance }}<br />
                  Bonus: {{ activeAccount.account.total.win_bonus }}<br />
                  Freespins Win: {{ activeAccount.account.total.freespin_win }}
                </span>
                </v-tooltip>
              </td>
              <td align="right">{{ activeAccount.account.total.win }}</td>
            </tr>
            <tr>
              <td><b>Total Correction</b></td>
              <td align="right">{{ activeAccount.account.total.correction }}</td>
            </tr>
            <tr>
              <td>
                <b>Total GGR</b>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="blue darken-4" class="ml-2" style="cursor: pointer;" v-on="on">info</v-icon>
                  </template>
                  <span>
                  Balance: {{ activeAccount.account.total.ggr_balance }}<br />
                  Bonus: {{ activeAccount.account.total.ggr_bonus }}
                </span>
                </v-tooltip>
              </td>
              <td align="right">{{ activeAccount.account.total.ggr }}</td>
            </tr>
            <tr>
              <td><b>Total NGR</b></td>
              <td align="right">{{ activeAccount.account.total.ngr }}</td>
            </tr>
            <tr>
              <td><b>Extra Purchase</b></td>
              <td align="right">{{ activeAccount.account.total.extra_purchase }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>

      <v-container class="text-center pa-0">
        <v-btn small color="info" @click="$store.dispatch('manual_transaction/open', activeAccount.account)" v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: ['balance', 'refund', 'bonus', 'freespins', 'bonus_template', 'respin']})">
          Manual Transaction
          <v-icon class="ml-2">monetization_on</v-icon>
        </v-btn>
      </v-container>
    </material-card>

    <v-dialog
      v-model="safebox.dialog"
      max-width="400"
    >
      <v-card>
        <v-card-title
          v-text="safebox.mode === 'withdraw' ? 'Withdraw from Safebox' : 'Deposit to Safebox'"
        />
        <v-card-text>
          <v-text-field
            v-model.number="safebox.amount"
            label="Amount"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            :loading="safebox.loading"
            @click="safebox.amount = 0, safebox.dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :loading="safebox.loading"
            :disabled="!safebox.amount || safebox.amount > activeAccount.account.balance"
            @click="updateSafebox"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-col>
</template>

<style>
  .select-item-border:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12)
  }

  .withdraw-request-limit-tf {
    width: 65px;
    padding-top: 5px;
  }

  .withdraw-limit-tf {
    padding-top: 5px;
  }

  .withdraw-limit-tf input,
  .withdraw-request-limit-tf input {
    text-align: right;
  }

  .account-info-finance td {
    height: 42px !important;
  }

  .highlighted-row {
    td:first-child {
      border-left: 3px solid #f55a4e;
    }
    background-color: color-mix(in srgb, #f55a4e 12%, transparent);
  }
</style>

<script>
  import { set, get, capitalize } from 'lodash'
  import { mapGetters } from 'vuex'
  import { API } from '@/utils/api'

  export default {

    props: [],
    components: {
      WithdrawLimitUpdate: () => import('@/components/user/dashboard/finance/WithdrawLimitUpdate'),
      ManualTransaction: () => import('@/components/helper/ManualTransaction'),
      DefaultHistory: () => import('@/components/helper/DefaultHistory')
    },

    data: () => ({
      limit: {
        item: {},
        loading: false,
        dialog: false,
      },
      safebox: {
        mode: null,
        amount: 0,
        dialog: false,
        loading: false,
      },
    }),
    computed: {
      ...mapGetters({ activeAccount: 'account/active' }),
      withdrawAllowedLength () {
        let width = (this.activeAccount.account.withdraw_allowed.toString().length * 11) + 15

        if (width < 40) width = 40

        if (this.$store.state.auth.checkAccess({ key: 'withdraw_pending_limit', value: true })) {
          width += 28
        }

        return width
      },
      dailyLimitPercent () {
        if (!this.activeAccount.account.withdraw_limits.max_per_day) return 0
        return (this.activeAccount.account.withdraw_limits_stats.day / this.activeAccount.account.withdraw_limits.max_per_day) * 100
      },
      weeklyLimitPercent () {
        if (!this.activeAccount.account.withdraw_limits.max_per_week) return 0
        return (this.activeAccount.account.withdraw_limits_stats.week / this.activeAccount.account.withdraw_limits.max_per_week) * 100
      },
      monthlyLimitPercent () {
        if (!this.activeAccount.account.withdraw_limits.max_per_month) return 0
        return (this.activeAccount.account.withdraw_limits_stats.month / this.activeAccount.account.withdraw_limits.max_per_month) * 100
      },
      canAdjustWithdrawalLimits () {
        return this.$store.state.auth.checkAccess({ key: 'withdraw_limits', value: true })
      },
      trueplayFormatted () {
        if (!this.activeAccount.trueplay.data) {
          return ''
        }

        const {
          user_currency,
          user_currency_balance,
          balance,
          token_name
        } = this.activeAccount.trueplay.data

        return `${user_currency_balance} ${user_currency} / ${balance} ${token_name}`
      },

      canSelectAllPaymethods () {
        return Array.isArray(this.activeAccount.paymethods.items) ? this.activeAccount.paymethods.items.some(({ name }) => !(this.activeAccount.account.data.whitelisted || []).includes(name)) : false
      }
    },

    watch: {
      'activeAccount.account.data.whitelisted': {
        handler: function (v) {
          this.sortPayemthods()
        },
        deep: true
      }
    },

    methods: {
      capitalize,
      openWithdrawLimitForm (item) {
        this.limit.item = {
          ...item,
          login: this.activeAccount.account.login,
          account_id: this.activeAccount.account.account_id,
        }
        this.limit.dialog = true
      },

      saveWithdrawLimit (item, to_delete = false) {
        if (to_delete) {
          item.to_delete = true
        }

        item.history = this.activeAccount.account.withdraw_limits

        this.limit.loading = true

        return API.call('/settings/withdraw_limits/update.json', item).then(resp => {
          this.activeAccount.account.withdraw_limits.max = resp.data.max
          this.activeAccount.account.withdraw_limits.min = resp.data.min
          this.activeAccount.account.withdraw_limits.max_per_day = resp.data.max_per_day
          this.activeAccount.account.withdraw_limits.max_per_month = resp.data.max_per_month
          this.activeAccount.account.withdraw_limits.max_per_week = resp.data.max_per_week
          this.activeAccount.account.withdraw_limits.level = resp.data.level

          this.limit.dialog = false
        }).finally(() => {
          this.limit.loading = false
        })
      },

      sortPayemthods () {
        this.$store.commit('account/sortPaymethodsWhitelist', {})
      },

      toUpdate: async function (_, field, message) {
        if (await this.$root.$confirm('Confirm', message)) {

          API.call('/$v/account/update.json', {
            login: this.activeAccount.account.login,
            account_id: this.activeAccount.account.account_id,
            fields: { [field]: get(this.activeAccount.account, field) },
          }, this.activeAccount.account).then(resp => {

            set(this.activeAccount.initAccount, field, get(resp.data, field))

            return resp.data
          }).then(r => {
            this.$notification.show = true
            this.$notification.message = 'Account updated'
            this.$notification.type = 'success'
          }).catch(e => {
          })

        } else {
          this.$nextTick(() => {
            set(this.activeAccount.account, field, get(this.activeAccount.initAccount, field))
          })
        }
      },

      updateSafebox () {
        this.$root.$confirm('Confirm', 'Update user Safebox balance?')
          .then(yes => {
            if (!yes) {
              return
            }
            this.safebox.loading = true
            API.call(`/$v/account/safebox/${this.safebox.mode}.json`, {
              login: this.activeAccount.account.login,
              account_id: this.activeAccount.account.account_id,
              amount: this.safebox.amount,
            })
              .then(() => {
                set(
                  this.activeAccount.account, 'safebox_balance',
                  this.activeAccount.account.safebox_balance + (this.safebox.amount * (this.safebox.mode === 'withdraw' ? -1 : 1))
                )
                set(
                  this.activeAccount.account.balance,
                  this.activeAccount.account.balance + (this.safebox.amount * (this.safebox.mode === 'deposit' ? -1 : 1))
                )
              })
              .finally(() => {
                this.safebox.loading = false
                this.safebox.dialog = false
                this.safebox.amount = 0
              })
          })
      },

      onSelectAllPaymethods () {
        this.activeAccount.account.data.whitelisted = this.activeAccount.paymethods.items.map(({ name }) => name)
        this.toUpdate(this.activeAccount.account.data.whitelisted, 'data.whitelisted', 'Do you want to change whitelist?')
      }
    },

  }
</script>
